class DesignYourPlanNewCustomer{
  currencyHandler = new Intl.NumberFormat('en-GB', {style: 'currency',currency: "GBP"});
  mealPicker = null;
  options = {
    apiUrl: "https://fuelhub-order.herokuapp.com/design_your_plan/",
    maxGoals:3,
    animationDuration:500,
    steps:["goals","plan","delivery","meals","extra"],
  };
  dialog= {
    action:"loading", //what to do next after click ok
    data:null //data pass to next action after click ok
  };
  data = {
    steps:{
      status:[1, 0, 0, 0, 0], // 0: disabled, 1: ready, 2: active, 3: done
      currentStepIdx: -1, 
      prevStep:-1
    },
    busy:false,
    goals:[],
    delivery:{date:"", day:""},
    plan:{},
    first_visit:true
  };
  constructor(options, data) {
    const _self = this;

    if (options != null){
      this.options = options;
    }
    if (data != null){
      this.data = data;
    }

    //progress action
    this.initProgress();
    
    //goal action
    this.initGoals();
    
    // buy option action
    this.initBuyOption();
    
    /*delivery date*/
    this.initDelivery();

    /*meals picker action*/
    this.initMealsPicker();


    /*dialog*/
    this.initDialog();


    /*window resize*/

    $( window ).on( "resize", function() {
      _self.updateUI();
    } );

    document.addEventListener("click", function (e) {
      const anchor = e.target.closest('a[href^="#"]');
      if (anchor) {
        e.preventDefault(); // stop browser from jumping
        // Optional: still update URL hash without scrolling
        const id = anchor.getAttribute("href").substring(1);
        history.pushState(null, "", "#" + id);
        // setTimeout(function(){
        //   $("html, body").animate({
        //     scrollTop: $("#" + id).offset().top - 150
        //   }, 300);
        // }, 100);
        $("html, body").animate({
          scrollTop: $("#" + id).offset().top - 150
        }, 100);
      }
    });
    //init step
   
    // Log when .design-your-plan__progress_list touches the top of the window
    $(function() {
      function logIfAtTop() {
        var $progressList = $(".design-your-plan__progress_list");
        var $planStepsContainer = $("#design-your-plan-steps__container");
        if ($progressList.length === 0) return;
        if ($(window).scrollTop() >= 300) {
          $progressList.addClass("sticky-progress-bar");
          $planStepsContainer.addClass("sticky-progress-bar");
        } else {
          $progressList.removeClass("sticky-progress-bar");
          $planStepsContainer.removeClass("sticky-progress-bar");
        }
      }
      
      function updateProgressNavigation() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();
        var offset = windowHeight * 0.3; // 30% from top of viewport
        var prevSection = '';
        var prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box";
        var currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box";


        $(".design-your-plan__progress_list li").each(function(){
          if ($(this).hasClass("active")){
            var prevSectionIdx = parseInt($(this).attr("stepidx"));
            if (prevSectionIdx == 0){
              prevSection = "goals";
              prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-goals";
            }
            if (prevSectionIdx == 1){
              prevSection = "plan";
              prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-plan";
            }
            if (prevSectionIdx == 2){
              prevSection = "delivery";
              prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-delivery";
            }
            if (prevSectionIdx == 3){
              prevSection = "meals";
              prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals";
            }
            if (prevSectionIdx == 4){
              prevSection = "ending";
              prevSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-ending";
            }

          }
        });


        var currentSection = '';
        var currentSectionTracking = 'Onboarding';
        
        // Check if user is 500px or less from bottom of page
        var distanceFromBottom = documentHeight - (scrollTop + windowHeight);
        if (distanceFromBottom <= 500) {
          // User is 500px or less from bottom, activate fourth nav item
          $(".design-your-plan__progress_list li").removeClass("active");
          $(".design-your-plan__progress_list li[stepidx='3']").addClass("active");
          if (window.innerWidth < 1024){
            $(".order-summary-container").addClass("reveal");
          }
          return;
        } else {
          $(".order-summary-container").removeClass("reveal");
        }
        
        // Check which section is currently in view
        var $goalsSection = $("#design-your-plan__step-goals");
        var $buyoptionSection = $("#design-your-plan__step-plan");
        var $deliverySection = $("#design-your-plan__step-delivery");
        var $mealsSection = $("#design-your-plan__step-meals");
        var $endingSection = $("#design-your-plan__step-ending");
        if ($goalsSection.length && scrollTop + offset >= $goalsSection.offset().top && scrollTop + offset < $goalsSection.offset().top + $goalsSection.outerHeight()) {
          currentSection = 'goals';
          currentSectionTracking = 'Onboarding_Goals';
          currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-goals";
          
        } else if ($buyoptionSection.length && scrollTop + offset >= $buyoptionSection.offset().top && scrollTop + offset < $buyoptionSection.offset().top + $buyoptionSection.outerHeight()) {
          currentSection = 'plan';
          currentSectionTracking = 'Onboarding_Plan';
          
          currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-plan";
          
        } else if ($deliverySection.length && scrollTop + offset >= $deliverySection.offset().top && scrollTop + offset < $deliverySection.offset().top + $deliverySection.outerHeight()) {
          currentSection = 'delivery';
          currentSectionTracking = 'Onboarding_Delivery';
          currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-delivery";
          
        } else if ($mealsSection.length && scrollTop + offset >= $mealsSection.offset().top && scrollTop + offset < $mealsSection.offset().top + $mealsSection.outerHeight()) {
          currentSection = 'meals';
          currentSectionTracking = 'Onboarding_Meals';
          currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-meals";
          
        } else if ($endingSection.length && scrollTop + offset >= $endingSection.offset().top && scrollTop + offset < $endingSection.offset().top + $endingSection.outerHeight()) {
          currentSection = 'ending';
          currentSectionTracking = 'Onboarding_Ending';
          currentSectionUrl = "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-ending";
        }
        
        //GA tracking
          
        if (prevSection != currentSection){
          // window.dataLayer.push({
          //   event: 'Onboarding_Goals'
          // }); 
          console.log("currentSection: "+currentSection);
        
          if (currentSection == "goals"){
            window.history.pushState(null,null,'#design-your-plan__step-goals');
          }
          if (currentSection == "plan"){
            window.history.pushState(null,null,'#design-your-plan__step-plan');
          }

          if (currentSection == "delivery"){
            window.history.pushState(null,null,'#design-your-plan__step-delivery');
          }

          if (currentSection == "meals"){
            window.history.pushState(null,null,'#design-your-plan__step-meals');
          
          }
          if (typeof gtag !== "undefined") { 
            //console.log("gtag ready");
            gtag('event', "OnboardingJourney", {
              plan_type: window.designYourPlan.data.plan.type,
              pageUrl: currentSectionUrl,
              pageTitle:currentSectionTracking.replace("_"," - "),
              previousUrl: prevSectionUrl
            });
            gtag('event', currentSectionTracking, {
              plan_type: window.designYourPlan.data.plan.type,
              pageUrl: currentSectionUrl,
              pageTitle:currentSectionTracking.replace("_"," - "),
              previousUrl: prevSectionUrl
            });
            // window.dataLayer.push({
            //   'event': 'OnboardingJourney',
            //   'pageUrl': currentSectionUrl,
            //   'pageTitle':currentSectionTracking.replace("_"," - "),
            //   'previousUrl': prevSectionUrl
            // });
          }  else {
            //console.log("gtag missing");
          }
        }


        // Update progress list active states
        if (currentSection) {
          $(".design-your-plan__progress_list li").removeClass("active");
          switch(currentSection) {
            case 'goals':
              $(".design-your-plan__progress_list li[stepidx='0']").addClass("active");
              break;
            case 'plan':
              $(".design-your-plan__progress_list li[stepidx='1']").addClass("active");
              break;
            case 'delivery':
              $(".design-your-plan__progress_list li[stepidx='2']").addClass("active");
              break;
            case 'meals':
              $(".design-your-plan__progress_list li[stepidx='3']").addClass("active");
              break;
            case 'ending':
              $(".design-your-plan__progress_list li[stepidx='4']").addClass("active");
              break;
          }
        }
      }
      
      $(window).on("scroll resize", function() {
        logIfAtTop();
        updateProgressNavigation();
      });
      logIfAtTop();
      updateProgressNavigation();
    });

  } // constructor

  /*utilities*/
  setCookie(cname, cvalue, exdays) {
      const d = new Date();
      d.setTime(d.getTime() + (exdays*2*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }

  /*main function call*/
  start(){
    this.verifyNRestoreSavedData();
     
    if (this.data.steps.currentStepIdx == -1){
     this.gotoStepByIdx(0);  
     
    } else {
     var _currentStepIdx = this.data.steps.currentStepIdx;
     this.data.steps.currentStepIdx -= 1;
     this.gotoStepByIdx(_currentStepIdx);
    }

    // Check if any button has active class, if not click the first button
    // if ($('.design-your-plan__delivery-buttons button.active').length === 0) {
    //   $('.design-your-plan__delivery-buttons button:first').click();
    // }

    // setTimeout(() => {
    //   $('.design-your-plan__delivery-buttons').addClass("page-loaded");
    // }, 1500);

    // Set default buying options
    let urlParams = new URLSearchParams(document.location.search);
    let defaultBuyingOption = urlParams?.get("buying_option") || "subscribe";
    if (defaultBuyingOption == "one-time"){
      // this.mealPicker.options.type = "one-time";
      // this.saveData();
      // this.updateUI();
      $(".order-type-content.onetime").trigger("click")
    } else {
      $(".order-type-content.subscription").trigger("click")
    }


  
    let defaulFilter = urlParams.get("filter");
    if (defaulFilter == "lite"){
      $(".type-filter-btn").each(function(){
        if ($(this).data("type") == "low-cal"){
          var _btn = $(this);
          setTimeout(function(){
            console.log("defaulFilter: "+$(_btn).data("type"));
            $(_btn).trigger("click");
          }, 100)
          
        }
      })
    }

    //window.abTest = urlParams.get("version");

    window.abTest = "a";

    if (document.location.href.includes("weekly-meal-prep-box/")){
      window.abTest = "b";
    }
    

    if (window.abTest == "b"){

    } else {
      //$(".meal-price").css({"display":"flex"});
    }

    if (urlParams.get("box")=="one-time"){
      $("#design-your-plan__step-plan-btn-skip").trigger("click");
        
      setTimeout(function(){
        //this.handleBuyOptionSkipClick();
        console.log("design-your-plan__step-plan-btn-skip");
        //$("#design-your-plan__step-plan-btn-skip").trigger("click");
        window.location.hash = "design-your-plan__step-delivery";
        //$(".design-your-plan__progress_list:nth-child(3)").trigger("click");
        //#design-your-plan__step-plan
      }, 500)
      
    }

  }
  
  /*verify and restore data*/

  verifyNRestoreSavedData(){
    // console.log("verifyNRestoreSavedData");
    var _data = "";
    var _dataJson; 
    
    _data = this.getCookie("dyp_data");
    // console.log(_data);
    if (_data != ""){
      _dataJson = JSON.parse(_data);
      // console.log(_dataJson);
    } else {
      _dataJson = {};
      this.data.first_visit = true;
      
      $('.design-your-plan__delivery-buttons button:first').click();
    }
    
    try{
      
      if (_dataJson.hasOwnProperty("steps") && _dataJson.hasOwnProperty("goals") && _dataJson.hasOwnProperty("delivery")){
        this.data = _dataJson;
        this.data.busy = false;
        
        // this.data.meals = [];
        //restore goals UI
        this.data?.goals?.forEach(g => {
          $("input[name='dyp_goals']").each(function( index ) {
            if ($( this ).val() == g) {
              $( this ).attr("checked", true);
              $( this ).parent().parent().addClass("active");
            }
          });
        })
        this.mealPicker.options.goals = this.data.goals;

        // restore delivery date UI

        function formatDateToWords(dateString) {
          // Parse MM/DD/YYYY
          const [month, day, year] = dateString.split('/');
          const date = new Date(`${year}-${month}-${day}`);
        
          // Get day of week and month name
          const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          const months = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
          ];
        
          // Ordinal suffix
          function ordinal(n) {
            if (n > 3 && n < 21) return n + 'th';
            switch (n % 10) {
              case 1: return n + 'st';
              case 2: return n + 'nd';
              case 3: return n + 'rd';
              default: return n + 'th';
            }
          }
        
          return `${days[date.getDay()]} ${ordinal(date.getDate())} ${months[date.getMonth()]}`;
        }

        var _deliveryDate = this.data.delivery.date;
        console.log('_deliveryDate', formatDateToWords(this.data.delivery.date));
        
        $(".plan-day-item").each(function(index) {
          if ($( this ).data("deliverydate") == _deliveryDate){
            $( this ).addClass("active");
            $(".order-summary-delivery").find(".order-summary-delivery-date").val(_deliveryDate);
          } else {
            $( this ).removeClass("active");
          }
        })
        if ($(".plan-day-item.active").length <= 0){
          //delivery not match
          $("#plan-day-item-0").addClass("active");
          this.data.delivery = {date:$("#plan-day-item-0").data("deliverydate"), day:$("#plan-day-item-0").data("day")};
          
          //clear meals if new delivery date
          this.mealPicker.clearPlanData();
          this.mealPicker.setDeliveryDate(this.data.delivery);
          this.data.plan = this.mealPicker.getPlanData();
        } else {
          this.mealPicker.setDeliveryDate(this.data.delivery);
          this.data.plan.busy = false;
          this.mealPicker.setPlanData(this.data.plan);
          
        }
        
        
        
      }

      if (this.data.goals.length > 0 ){
        $("#type-filter-btn-goals").trigger("click");
      }

    } catch(error){
      console.log(error);
      console.log("not saved data found");
    }
  }

  /*step progress*/
  initProgress(){
    $(".design-your-plan__progress_list").find("li").click((e) => {
      const step = $(e.currentTarget).attr("stepIdx");
      // this.gotoStepByIdx(step);
      // console.log("initProgress"+step);
      // var top = 0;
      // if (step == 4){

      // } else {
      //   if (step == 1){
      //     top = $("#design-your-plan__step-delivery").offset().top - 150;
      //   }
      //   if (step == 2){
      //     top = $("#shopify-section-design-your-plan-step-meals").offset().top - 180;
      //   }
      //   $("html, body").animate({
      //     scrollTop: top
      //   }, 300);
      // }

    });
  }
  
  /*step section functions*
  **** goals
  */
  handleGoalsNextClick(){
    this.data.steps.status[1] = 1;
    this.mealPicker.options.goals = this.data.goals;
    this.saveData();
    this.updateUI();
    // $("html, body").animate({
    //   scrollTop: $("#design-your-plan__step-delivery").offset().top - 150
    // }, 300);
    // this.gotoStepByIdx(1);
  }
  
  handleGoalsSkipClick(){
    this.data.steps.status[1] = 1;
    this.clearAllGoals();
    this.saveData();
    this.updateUI();
    $(".type-filter-btn-all").trigger("click");
    // $("html, body").animate({
    //   scrollTop: $("#design-your-plan__step-delivery").offset().top - 150
    // }, 300);
    // this.gotoStepByIdx(1);
  }
  
  clearAllGoals(){
    $("#design-your-plan__goals-list").find(".checkbox-input").prop("checked", false);
    this.data.goals = [];
    this.mealPicker.options.goals = this.data.goals;
    $("#design-your-plan__goals-count").html(this.data.goals.length);
    // Remove active class from all goal items
    $("#design-your-plan__goals-list").find(".checkbox-input").parent().parent().removeClass("active");
  }

  initGoals(){
    
    $("#design-your-plan__goals-list").find(".checkbox-input").click((e) => {
      if ($(e.currentTarget).is(":checked")){
        if (this.data.goals.length >= this.options.maxGoals){
          //skip if reach max
          return false;
        }
        this.data.goals.push($(e.currentTarget).val());
        $(e.currentTarget).parent().parent().addClass("active");
      } else {
        this.data.goals = [...this.data.goals].filter(function(g) { return g !== $(e.currentTarget).val() })
        $(e.currentTarget).parent().parent().removeClass("active");
      }
      $("#design-your-plan__goals-count").html(this.data.goals.length);
      this.mealPicker.options.goals = this.data.goals;
    
      this.saveData();
      $(".type-filter-btn-all").trigger("click");
      if (this.data.goals.length > 0 ){
        $("#type-filter-btn-goals").trigger("click");
      }

      this.updateUI();
   });

    
    $("#design-your-plan__step-goals-btn-next").click((e) =>{
      this.handleGoalsNextClick();
      //return false;
    });
    $("#design-your-plan__step-goals-btn-skip").click((e) =>{
      this.handleGoalsSkipClick();
      //return false;
    });
    

  }
  /*step section functions*
  **** buyoption
  */

  handleBuyOptionNextClick(){
    this.data.steps.status[2] = 1;
    $(".order-type-content.subscription").trigger("click")
    this.saveData();
    this.updateUI();
    // $("html, body").animate({
    //   scrollTop: $("#design-your-plan__step-delivery").offset().top - 150
    // }, 300);
    // this.gotoStepByIdx(1);
  }
  
  handleBuyOptionSkipClick(){
    this.data.steps.status[2] = 1;
    $(".order-type-content.onetime").trigger("click")
    
    this.saveData();
    this.updateUI();
    // $("html, body").animate({
    //   scrollTop: $("#design-your-plan__step-delivery").offset().top - 150
    // }, 300);
    // this.gotoStepByIdx(1);
  }


  initBuyOption(){
    $("#design-your-plan__step-plan-btn-next").click((e) =>{
      this.handleBuyOptionNextClick();
      //return false;
    });
    $("#design-your-plan__step-plan-btn-skip").click((e) =>{
      this.handleBuyOptionSkipClick();
      //return false;
    });
  }
  /*step section functions*
  **** delivery
  */
  initDelivery(){
    $(".design-your-plan__days-container .design-your-plan__delivery-buttons .plan-day-item").click((e) =>{
      this.handleDeliveryDateClick(e)
      if (!this.data.first_visit){
        //this.data.first_visit just for this, it auto scroll to meal selection section when frist visit
        $("html, body").animate({
          scrollTop: $("#design-your-plan__step-meals").offset().top - 150
        }, 100);
      } else {
        this.data.first_visit = false;
      }
    });
  }
  changeDeliveryDate(date){
    $(".plan-day-item").each(function(index) {
      //console.log($( this ).data("deliverydate") + " : "+newDeliveryDate);
      if ($( this ).data("deliverydate") == date){
        $( this ).trigger("click");
      }
    })
  }
  handleDeliveryDateClick(e){
    //console.log("handleDeliveryDateClick");
    var newDeliveryDateStr = e.currentTarget.getAttribute("data-deliverydate");
    var newDeliveryDate = new Date(newDeliveryDateStr);

    // window.designYourPlan.showPlanDataBeforeSwapDeliveryDateDialog(newDeliveryDateStr);
    
    if (window.designYourPlan.mealPicker.isSameMenu(newDeliveryDate)){
      window.designYourPlan.handleDeliveryDateChange(newDeliveryDateStr);
      //window.designYourPlan.mealPicker.swapDeliveryDate(e.currentTarget.getAttribute("data-deliverydate"));
    } else {
      // console.log(window?.designYourPlan?.data?.meals)
      // console.log(window?.designYourPlan?.data?.meals.length)
      if ((window?.designYourPlan?.mealPicker?.data?.meals && window?.designYourPlan?.mealPicker?.data?.meals.length > 0) || (window?.designYourPlan?.mealPicker?.data?.extras && window?.designYourPlan?.mealPicker?.data?.extras.length > 0)){
        window.designYourPlan.showPlanDataBeforeSwapDeliveryDateDialog(newDeliveryDateStr);
      } else {
        window.designYourPlan.handleDeliveryDateChange(newDeliveryDateStr);
      }
      
    }


    
  }
  handleDeliveryDateChange(newDeliveryDate){
    $(".plan-day-item").each(function(index) {
      //console.log($( this ).data("deliverydate") + " : "+newDeliveryDate);
      if ($( this ).data("deliverydate") == newDeliveryDate){
        $( this ).addClass("active");
        window.designYourPlan.data.delivery.date = $( this ).data("deliverydate");
        window.designYourPlan.data.delivery.day = $( this ).data("day");
        window.designYourPlan.mealPicker.setDeliveryDate(window.designYourPlan.data.delivery);
      } else {
        $( this ).removeClass("active");
      }
    })
      
    this.data.steps.status[3] = 1;
    //this.data.delivery = {date:"", day:""};
    this.saveData();
    this.updateUI();
    // this.gotoStepByIdx(2);
  }

  

  /*step section functions*
  **** meals picker
  */
  
  initMealsPicker(){
    this.mealPicker = new DesignYourPlanMealPicker({customerType:"new", minMeals:5},{filterContainer:".design-your-plan-meal-filter-wrap", advancedFilterContainer:".design-your-plan-meal-filter-tags", mealsContainer:".design-your-plan-meals-selection-container",orderSummaryContainer:".order-summary-container"});
    
  }
  
  /*step change functions*/
  gotoStepByIdx(stepIdx){
    console.log("gotoStepByIdx: "+stepIdx);
      
    if (this.data.steps.status[stepIdx] == 0){
      console.log("step: "+stepIdx+" no ready");
      return;
    }
    if (this.data.steps.currentStepIdx == stepIdx){
      console.log("step: "+stepIdx+" is current step, done need to change");
      return;
    }
    if (this.data.busy){
      console.log("busy now");
      return;
    }
    
    this.data.busy = true;
    //reset to ready if status not disabled 
    this.data.steps.status = this.data.steps.status.map((s) => s>=1?1:0);
    this.data.steps.prevStep = this.data.steps.currentStepIdx;
    this.data.steps.currentStepIdx = parseInt(stepIdx);
    this.data.steps.status[this.data.steps.currentStepIdx] = 2; //update current step status to active
    //console.log(this.data.steps.currentStepIdx);
    //console.log(this.data.steps.status);
    this.updateUI();
    var _self = this;
    setTimeout(function(){
      _self.data.busy = false;
      _self.saveData();
    }, this.options.animationDuration);
    
  }
  gotoNextAni(nextStep){
    console.log("go to next step: "+nextStep);
    $("#design-your-plan__step_"+this.currentStepIdx).addClass("fadeOut");
    $("#design-your-plan__steps_container").css("height",Math.max($("#design-your-plan__step_"+this.currentStepIdx).outerHeight(), $("#design-your-plan__step_"+(nextStep)).outerHeight())+"px")
    
    this.gotoStepByIdx(nextStep);
    setTimeout(function(){
      $(".design-your-plan__step_content_container.fadeOut").css("display","none");
      $(".design-your-plan__step_content_container.fadeOut").removeClass("fadeOut");
      $("#design-your-plan__steps_container").css("height","auto");
    }, 500);
  }
  
  /*save data*/
  saveData(){
    this.data.plan = this.mealPicker.getPlanData();
    console.log("save data");
    console.log(this.data);
    this.setCookie("dyp_data",JSON.stringify(this.data),1);
  }
  
  /*update interface*/
  updateUI(){

    if (this.data.plan.type == "subscribe"){
      $(".design-your-plan__header-inner h1").html("Your Weekly Meal Prep Box.");
      $(".design-your-plan__header-description").show();
    } else {
      $(".design-your-plan__header-inner h1").html("Your Meal Prep Box.");
      $(".design-your-plan__header-description").hide();
    }

    $("#design-your-plan-steps__container").show();
    $("#design-your-plan-steps__container").removeClass("step_sticky");
    if (this.data.steps.currentStepIdx == 2){
      $("#design-your-plan-steps__container").addClass("step_sticky");
    }
    console.log("updateUI------>>>>>");
    console.log(this.data);
    /* update process */
    $(".design-your-plan__progress_list").find("li").each((idx, item) =>{
      $(item).attr('class',"");
      const step = $(item).attr("stepIdx");
      //console.log("step: "+step+", status: "+this.data.steps.status[step]);
      switch (this.data.steps.status[step]){
        case 1:
          $(item).addClass("ready");
          break;
        case 2:
          $(item).addClass("active");
          break;
        default:
          $(item).addClass("done");
          break;
      }
    })

    /* delivery  elements */
    if (this.mealPicker.data.type == "one-time"){
      $("#shopify-section-design-your-plan-step-delivery").find(".design-your-plan__step-content-desc").hide();
    } else {
      $("#shopify-section-design-your-plan-step-delivery").find(".design-your-plan__step-content-desc").show();
    }




    /*goals elements*/
    $("#design-your-plan__goals-count").html(this.data.goals.length);

    /*meals picker*/
    this.mealPicker.updateUI();
    if (this.mealPicker.data.type == "one-time"){
      $(".order-summary-delivery-upsell-first-week-total").find("p").html("Total: ");
    } else {
      $(".order-summary-delivery-upsell-first-week-total").find("p").html("Week One Total: ");
    }
    
    

  } 


  /*dialog*/
  initDialog(){
    $("#design-your-plan__dialog-container .dialog-close").click(function(){
      window.designYourPlan.closeDialog();
    })
    
    $("#dialog-btn-cancel").click(function(){
      window.designYourPlan.processDialogCancel();
    });
    
    $("#dialog-btn-ok").click(function(){
      window.designYourPlan.processDialogAction();
    });
  }
  showDialog(){
    if (this.dialog.action == "loading"){
      $("#design-your-plan__dialog-container .dialog-close").hide();
      
      $("#design-your-plan__dialog-container .dialog-btns-container").hide();
    } else {
      
      $("#design-your-plan__dialog-container .dialog-close").show();
      $("#design-your-plan__dialog-container .dialog-btns-container").show();
    }
    $("#design-your-plan__dialog-container").show();
    $("body").addClass("overflow-y-hidden");
  }
  closeDialog(){
    $("#design-your-plan__dialog-container").hide();
    $("body").removeClass("overflow-y-hidden");
    
  }
  processDialogCancel(){
    switch(this.dialog.action){
      case "clearPlanDataBeforeSwapeDelieveryDate":
        this.updateUI();
        break;
      default:
        break;
    }
    this.closeDialog();
  }
  processDialogAction(){
    switch(this.dialog.action){
      case "clearPlanDataBeforeSwapeDelieveryDate":
        $(".type-filter-btn-all").trigger("click");
        this.mealPicker.clearPlanData();
        this.handleDeliveryDateChange(this.dialog.data);
        break;
      default:
        break;
    }
    this.closeDialog();
  }

  // loading dialog
  showLoadingDialog(){
    var _loadingSpinner = `<center><span class="spinner"><img width="50" height="auto" src="https://cdn.shopify.com/s/files/1/0728/3802/1419/files/fuelhub-fire-animation-v2_transparent.gif?v=1762169933" alt="FuelHub"></span><br/></center>`;
    $(".dialog-content-container").html(_loadingSpinner+"Preparing your box, please wait...")
    this.dialog.action = "loading";
    this.dialog.data = null;
    this.showDialog();
  }

  //swap delivery date functions
  showPlanDataBeforeSwapDeliveryDateDialog(nextDeliveryDate){
    $(".dialog-content-container").html("Please note: Any changes made to your delivery day will remove any meals that have been previously selected.<br />Continue?")
    this.dialog.action = "clearPlanDataBeforeSwapeDelieveryDate";
    this.dialog.data = nextDeliveryDate;
    this.showDialog();
  }

  /*checkout*/
  checkout(){
    let checkoutParams = this.mealPicker.getCheckoutParams();
    // console.log(checkoutParams);
    // return;
    let discountCodeToApply = "";
    if (checkoutParams.type == "subscribe"){
      discountCodeToApply = checkoutParams.discount.map((d) => {
        return d.code;
      }).join(",");
    } 
    // else {
    //   discountCodeToApply = checkoutParams.discount.filter((d) => {
    //     return d.code.startsWith("ref_")
    //   }).map((d) => {
    //     return d.code;
    //   }).join(",");
    // }
    if (discountCodeToApply!=""){
      discountCodeToApply = "?discount="+discountCodeToApply;
    }
    //discountCodeToApply = "?discount=welcome20";
    //alert(discountCodeToApply);
    //return
    if (typeof gtag !== "undefined") { 
      gtag('event', "OnboardingJourney", {
        plan_type: window.designYourPlan.data.plan.type,
        pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-gotocheckout",
        pageTitle:"Onboarding - GoToCheckout",
        previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell"
      });
      gtag('event', "Onboarding_GoToCheckout", {
        plan_type: window.designYourPlan.data.plan.type,
        pageUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-gotocheckout",
        pageTitle:"Onboarding - GoToCheckout",
        previousUrl: "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell"
      });
      // window.dataLayer.push({
      //   'event': 'virtualPageview',
      //   'pageUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-gotocheckout",
      //   'pageTitle':"Onboardeing - GoToCheckout",
      //   'previousUrl': "https://fuelhub.co.uk/products/weekly-meal-prep-box#design-your-plan__step-upsell"
      // });
    }


    $.ajax({
      // Clear Cart
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      beforeSend: function () {
        //$("#loader").removeClass("hidden");
        window.designYourPlan.showLoadingDialog();
      },
      success: function () {
        $.ajax({
          // Add items to Cart
          type: "POST",
          url: "/cart/add.js",
          data: {
            items: checkoutParams.items,
          },
          dataType: "json",
          success: function (response) {
            let mainProductInCart = true;
            $.each(response.items, function(key,value) {
              if (value.id == checkoutParams.planProduct.vid){
                mainProductInCart = true;
              }
            }); 
            if (mainProductInCart){
              var _delivery_date_arr = checkoutParams.delivery.date.split("/"); 

              var _delivery_date = _delivery_date_arr[1]+"-"+_delivery_date_arr[0]+"-"+_delivery_date_arr[2];


              $.ajax({
                // Attach Date, Preference
                type: "POST",
                url: "/cart/update.js",
                data: {
                  attributes: {
                    "Delivery Date": _delivery_date,
                    "Preference": checkoutParams.dietaryPreference,
                    "Goals": checkoutParams.goals.join("|||"),
                    "portion": checkoutParams.portion,
                    "First Delivery": _delivery_date,
                    "Taster Box": "",
                  },
                },
                dataType: "json",
                success: function () {
                  window.designYourPlan.closeDialog();
                  window.location.href = "/checkout"+discountCodeToApply;
                },
              });
            
            } // update preference
          }, //add success
        }); // add
      }, //clear success
    }); // clear
    
  }
}